import React from "react";
import bgImage from "../../assets/servicesImages/erp/hero.png";
import icon1 from "../../assets/servicesImages/erp/1.png";
import icon2 from "../../assets/servicesImages/erp/2.png";
import icon3 from "../../assets/servicesImages/erp/3.png";
import icon4 from "../../assets/servicesImages/erp/4.png";
import icon5 from "../../assets/servicesImages/erp/5.png";
import icon6 from "../../assets/servicesImages/erp/6.png";
import icon7 from "../../assets/servicesImages/erp/7.png";
import icon8 from "../../assets/servicesImages/erp/8.png";
import icon9 from "../../assets/servicesImages/erp/9.png";
import icon10 from "../../assets/servicesImages/erp/10.png";
import icon11 from "../../assets/servicesImages/erp/11.png";
import icon12 from "../../assets/servicesImages/erp/12.png";
import icon13 from "../../assets/servicesImages/erp/13.png";
import icon14 from "../../assets/servicesImages/erp/14.png";
import icon15 from "../../assets/servicesImages/erp/15.png";
import icon16 from "../../assets/servicesImages/erp/16.png";
import icona from "../../assets/servicesImages/erp/a.png";
import iconb from "../../assets/servicesImages/erp/b.png";
import iconc from "../../assets/servicesImages/erp/c.png";
import icond from "../../assets/servicesImages/erp/d.png";
import icone from "../../assets/servicesImages/erp/e.png";
import iconf from "../../assets/servicesImages/erp/f.png";
import Slider from "react-slick";

const features = [
  { icon: icon1, title: "Admission Management", desc: "Effortlessly convert inquiries into confirmations with direct student management. Easily configurable for seamless online admissions." },
  { icon: icon2, title: "Student Management", desc: "Include photos, family details, document uploads, roll numbers, and built-in ID cards." },
  { icon: icon3, title: "Attendance Management", desc: "Track daily attendance with reports, absentee alerts, and percentage monitoring." },
  { icon: icon4, title: "Fees Management", desc: "Customize fees, handle concessions, auto-generate receipts, and send alerts." },
  { icon: icon5, title: "Timetable Management", desc: "Manage student and teacher timetables with alerts for overlaps." },
  { icon: icon6, title: "Academic", desc: "Organize classwork, homework, syllabuses, and lesson plans." },
  { icon: icon7, title: "Events & Activities", desc: "Dynamic calendar with custom colors and mobile app integration." },
  { icon: icon8, title: "Health Management", desc: "Predefined/custom check-ups, health records, and vaccine history." },
  { icon: icon9, title: "Student Assessment", desc: "Support for CBSE, ICSE, IB with mark-sheets and analytics." },
  { icon: icon10, title: "Human Resource", desc: "Manage recruitment, employee details, ID cards, and reports." },
  { icon: icon11, title: "Leave Management", desc: "Define leave types, policies, forms, and generate reports." },
  { icon: icon12, title: "Payroll", desc: "Department-based payrolls, slips, PF, tax management." },
  { icon: icon13, title: "Reports", desc: "Student and class reports, admissions, attendance, and more." },
  { icon: icon14, title: "Transport", desc: "Create transport routes, integrate fees, and view student route reports." },
  { icon: icon15, title: "Library", desc: "Manage books, issues, returns, and generate library reports." },
  { icon: icon16, title: "Hostel", desc: "Manage rooms, types, charges, and integrate with fees." }
];

const benefits = [
  { p1: "Cloud Based ERP", p2: "Access ERP from any device, anytime. No need to invest in servers or infrastructure." },
  { p1: "Real-Time Data", p2: "Get live updates on attendance, transport, and school activities." },
  { p1: "24/7 Support", p2: "Our support team is available anytime to assist your organization." },
  { p1: "Private & Secure", p2: "Data privacy is our top priority. We don’t share your info with third parties." },
];

const sliderItems = [
  { icon: icona, title: "BEST UI Design", desc: "Simple UI & fast navigation allow users to focus on work, not the tool." },
  { icon: iconb, title: "Customizable & Flexible", desc: "Fully adaptable ERP modules to fit your institution’s unique needs." },
  { icon: iconc, title: "Zero Maintenance", desc: "We handle software upgrades & protection. No extra charges." },
  { icon: icond, title: "Easily Accessible", desc: "Web-based ERP available on desktop & mobile." },
  { icon: icone, title: "Fast Implementation", desc: "Deploy ERP quickly with rule-based configuration." },
  { icon: iconf, title: "Real-Time Access", desc: "Live access to student data, schedules, transport, and more." },
];

const settings = {
  className: "center",
  centerMode: true,
  infinite: true,
  slidesToShow: 3,
  speed: 500,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
        breakpoint: 3000, // large screens default
        settings: {
            slidesToShow: 4,
        },
    },
    {
        breakpoint: 1024, // md to lg
        settings: {
            slidesToShow: 2.5,
            centerMode: false,
        },
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            centerMode: false,
        }
    },
    {
        breakpoint: 480,
        settings: {
            slidesToShow: 1,
            centerMode: false,
        }
    }
]
};
  
const ERP = () => {
  return (
    <div className="font-sans text-gray-800 bg-gray-50">
  {/* Hero Section */}
  <section 
    className="h-[40vh] sm:h-[50vh] md:h-[60vh] lg:h-screen w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center" 
    style={{ backgroundImage: `url(${bgImage})` }}
  >
    <div className="absolute inset-0 bg-black bg-opacity-50" />
    <div className="relative z-10 flex flex-col justify-center h-full px-6 sm:px-10 md:px-20 lg:px-32 text-white">
      <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4">All-In-One ERP for School and College</h1>
      <p className="text-base sm:text-lg md:text-xl lg:text-2xl">All reports on one click!</p>
    </div>
  </section>
      <section className="max-w-6xl mx-auto py-6 sm:py-8 md:py-10 px-6 sm:px-8 md:px-10 text-center">
  <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4 md:mb-6">
    Why eSparse School ERP?
  </h2>
  <p className="text-gray-600 leading-relaxed text-sm sm:text-base md:text-lg">
    A school ERP is a collection of software designed to manage daily school tasks. It allows schools to digitize their operations, improve efficiency, and save time.
    <br /><br />
    Modern schools use ERPs to streamline administrative operations, manage resources, and improve productivity.
  </p>
</section>



{/* HRMS Section */}
<section className="bg-white py-8 px-6 text-center">
  <h2 className="text-3xl font-bold mb-4">Why ESPARSE HRMS?</h2>
  <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto">
    Esparse HRMS supports extended working hours and eliminates system flaws with a personalized HRMS solution.
  </p>
</section>


    {/* Feature Cards */}
<section className="py-12 sm:py-16 md:py-20 px-6 sm:px-8 md:px-10">
  <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
    {features.map((f, i) => (
      <div key={i} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:scale-[1.05] hover:text-blue-800">
        <img src={f.icon} alt={f.title} className="w-16 h-16 mx-auto mb-4 filter grayscale hover:grayscale-0" />
        <h4 className="text-xl sm:text-2xl font-semibold text-center mb-2">{f.title}</h4>
        <p className="text-sm sm:text-base text-gray-600 text-center">{f.desc}</p>
      </div>
    ))}
  </div>
</section>



      {/* Slider */}
      <section className="bg-gradient-to-b from-gray-100 to-gray-200 py-16 relative">
  <h2 className="text-center text-3xl font-bold mb-10">SPARSE ERP FEATURES</h2>
  <div className="relative max-w-7xl mx-auto px-6">
    <Slider {...settings}>
      {sliderItems.map((item, idx) => (
        <div key={idx} className="px-4">
          <div className="bg-white rounded-xl shadow hover:shadow-xl p-6 h-[250px] flex flex-col justify-start items-center gap-4 text-center">
            <img src={item.icon} alt={item.title} className="w-14 h-14" />
            <h4 className="text-lg font-bold">{item.title}</h4>
            <p className="text-sm text-gray-600">{item.desc}</p>
          </div>
        </div>
      ))}
    </Slider>
  </div>
</section>


      {/* Benefits */}
      <section className="py-20 bg-white px-6">
      <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-center font-bold mb-6 sm:mb-8 md:mb-10 lg:mb-12">
  Key Benefits of Sparse School/College ERP
</h2>
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((b, index) => (
            <div key={index} className="bg-gray-50 border border-gray-200 rounded-xl p-6 shadow hover:shadow-md transition">
              <h4 className="text-lg font-semibold text-center text-gray-800 mb-3 hover:text-indigo-600 transition duration-300">{b.p1}</h4>
              <p className="text-sm text-gray-600 text-center">{b.p2}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ERP;
